<template>
  <div id="app">
    <!--banner start-->
    <banner></banner>
    <!--banner end-->

    <!--routes start-->
    <div class="active_tab">
      <ul class="clearfix">
        <li>
          <router-link to="/active" @click="">热门活动</router-link>
        </li>
        <li>
          <router-link to="/history" @click="">历史活动</router-link>
        </li>
      </ul>
    </div>
    <div class="active_cont">
      <router-view></router-view>
    </div>
    <!--routes end-->

    <!--toTop start-->
    <to-top></to-top>
    <!--toTop end-->

    <!--slideNav start-->
    <!--<slide-nav></slide-nav>-->
    <!--slideNav end-->
  </div>
</template>

<script>
  import toTop from './components/ToTop.vue'
  // import slideNav from './components/SlideNav.vue'
  import banner from './components/Banner.vue'
  // import {
  //   swiper,
  //   swiperSlide
  // } from 'vue-awesome-swiper'

  export default {
    name: 'app',
    components: {
      "to-top": toTop,
      // "slide-nav":slideNav,
      "banner":banner
      // swiper,
      // swiperSlide
    },
    data() {
      return {        
        // swiperOption: {
        //   autoplay: 3500,
        //   setWrapperSize: true,
        //   pagination: '.swiper-pagination',
        //   paginationClickable: true,
        //   mousewheelControl: true,
        //   observeParents: true,
        // },
        // swiperSlides: []
      }
    },
    mounted() {
      
      // this.addCarousel()
      // setInterval(() => {
      //   let swiperSlides = this.swiperSlides
      // }, 3000)
    },
    methods: {     
      // addCarousel() {
      //   let _this = this;
      //   this.$http.get('./mock/list.json')
      //     .then(function (res) {
      //       _this.swiperSlides = res.data.object
      //     })
      //     .catch(function (err) {
      //       console.log(err)
      //     })
      // }  
    }
  }
</script>

<style scoped>
  #app {
    min-height: 100%;
  }
  
  router-link {
    color: #323232;
  }
  
  .router-link-active {
    color: #fff;
    background: #e21919;
  }
  
  .active_tab ul li a {
    display: block;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// App.vue?50884d2e